import { render } from "./FridgeDoorMonitorDailyItem.vue?vue&type=template&id=1936bd35&scoped=true&ts=true"
import script from "./FridgeDoorMonitorDailyItem.vue?vue&type=script&lang=ts"
export * from "./FridgeDoorMonitorDailyItem.vue?vue&type=script&lang=ts"

import "./FridgeDoorMonitorDailyItem.vue?vue&type=style&index=0&id=1936bd35&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1936bd35"]])

export default __exports__